<div class="popup-header"> {{data.refrence}} - {{data.status}}</div>

<div mat-dialog-content>

<app-table-standard-layout [dataSource$]="combObs$" [title]="'Filling reports'" [rowActionButtons]="rowActionButtons"
[columnSettings]="columnSettings" [sortingArray]='sortArray'></app-table-standard-layout>

</div>

<div mat-dialog-actions align="end">
  <button type="button" mat-raised-button (click)="onNoClick()">Cancel</button>
  
</div>
